// extracted by mini-css-extract-plugin
export var approvalCard = "PitchListPage-module__approvalCard___cy49-";
export var approvalContent = "PitchListPage-module__approvalContent___K0VkZ";
export var approvalDescription = "PitchListPage-module__approvalDescription___gjaD6";
export var approvalIcon = "PitchListPage-module__approvalIcon___jd4cT";
export var approvalLink = "PitchListPage-module__approvalLink___Bytwf";
export var approvalTitle = "PitchListPage-module__approvalTitle___+PI26";
export var beforeYouStartBody = "PitchListPage-module__beforeYouStartBody___YXeVq";
export var beforeYouStartCard = "PitchListPage-module__beforeYouStartCard___GxysN";
export var beforeYouStartDivider = "PitchListPage-module__beforeYouStartDivider___G75qI";
export var beforeYouStartHeader = "PitchListPage-module__beforeYouStartHeader___8aJdL";
export var beforeYouStartIcon = "PitchListPage-module__beforeYouStartIcon___9pxAc";
export var beforeYouStartTitle = "PitchListPage-module__beforeYouStartTitle___2Gi0M";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var pageHeader = "PitchListPage-module__pageHeader___dq0Hk";
export var pageSubtitle = "PitchListPage-module__pageSubtitle___96cPF";
export var pageTitle = "PitchListPage-module__pageTitle___0N6Uv";
export var programInfoCard = "PitchListPage-module__programInfoCard___CMEOC";
export var programInfoDescription = "PitchListPage-module__programInfoDescription___JTiCf";
export var programInfoImage = "PitchListPage-module__programInfoImage___eDQta";
export var programInfoText = "PitchListPage-module__programInfoText___J67bv";
export var programInfoTitle = "PitchListPage-module__programInfoTitle___mR8EN";